import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import ReactResizeDetector from 'react-resize-detector';
import { unregister } from './registerServiceWorker';
import MainRouter from './MainRouter';
import Nav from './components/nav/Nav';
import UserProvider from './components/auth/UserProvider';
import SplashMessageProvider from './components/splashMessage/SplashMessageProvider';
import SplashMessages from './components/splashMessage/SplashMessages';
import './style.css';
import { breakpoints } from './const';
import * as Sentry from '@sentry/browser';
import TagManager from 'react-gtm-module'

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN
});

class Root extends React.Component {
  state = {
    windowWidth: 0,
    windowHeight: 0,
    isMobile: true,
    hideNav: false
  };

  render() {
    const { hideNav } = this.state;

    const classes = hideNav ? '' : 'page';

    return (
      <SplashMessageProvider>
        <UserProvider>
          <BrowserRouter>
            <div className={classes}>
              {!hideNav && <Nav windowWidth={this.state.windowWidth} />}
              <MainRouter
                windowWidth={this.state.windowWidth}
                isMobile={this.state.isMobile}
              />
              <SplashMessages />
            </div>
          </BrowserRouter>
          <ReactResizeDetector
            handleWidth
            handleHeight
            onResize={this.onResize}
            refreshMode="throttle"
            refreshRate={100}
          />
        </UserProvider>
      </SplashMessageProvider>
    );
  }

  /* Resize */
  onResize = (windowWidth, windowHeight) => {
    const isMobile = windowWidth < breakpoints.tablet;
    this.setState({ isMobile, windowWidth, windowHeight });
  };

  componentDidMount() {
    const isLogin = window.location.pathname.includes('login');
    const isNew =
      (window.location.pathname.includes('client-profile') &&
        !window.location.pathname.includes('old')) ||
      (window.location.pathname.includes('new-client') &&
        !window.location.pathname.includes('old'));

    // Nav not mounted on new Client dashboard.  Also, Nav will reside inside login page component - necessary for avoiding a flash of the nav when redirected after login
    this.setState({ hideNav: isLogin || isNew });
  }
}

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID
}
TagManager.initialize(tagManagerArgs)

render(<Root />, document.getElementById('root'));
// registerServiceWorker();
unregister();



// WEBPACK FOOTER //
// ./src/index.js